import React from "react";
import { Table } from "reactstrap";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";

import style from "../Grid.module.scss";

const RecurringCommissionsAccounts = ({ accounts }) => (
  <div className={style.grid}>
    <h6 className="my-3">Accounts</h6>
    <Table responsive hover>
      <thead>
        <tr>
          <th>Account</th>
          <th className="text-right">Total</th>
        </tr>
      </thead>
      <tbody>
        {accounts.map((item) => (
          <tr key={item.ItemId}>
            <td>{item.AccountName}</td>
            <td className="text-right">
              <FormattedNumber value={item.RecurringCommissionTotal} dataTypeDecimalName="currency" />
            </td>
          </tr>
        ))}
        {accounts.length === 0 && (
          <tr>
            <td colSpan={8} style={{ textAlign: "center" }}>
              No Accounts
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </div>
);

export default RecurringCommissionsAccounts;
